import {tns} from "tiny-slider/src/tiny-slider";  // es6 module

try {
  var bannerSliders = [];
  var targets = document.querySelectorAll(".banner-slider .banner-slider__list");

  for(var i=0; i < targets.length; i++) {
    bannerSliders[i] = new tns({
      container: targets[i],
      controls: false,
      nav: false,
      autoplay: true,
      mode: "gallery",
      speed: 1500,
      autoplayResetOnVisibility: true,
      autoplayButtonOutput: false,
    });
  }
}catch(err) {
  console.log(err)
};

try {
  var heroSliders = [];
  var targets = document.querySelectorAll(".hero-slider .hero-slider__list");

  for(var i=0; i < targets.length; i++) {
    heroSliders[i] = new tns({
      container: targets[i],
      controls: false,
      nav: false,
      autoplay: true,
      mode: "gallery",
      speed: 1500,
      autoplayResetOnVisibility: true,
      autoplayButtonOutput: false,
    });
  }
}catch(err) {
  console.log(err)
};
